export const laserpointer = {
  icon: '20px',
};
